import { layoutWorkspace } from './../_common/layout.workspace';
import { ConfigSection } from '@components-fabric';
import { DashboardScreen } from './screens.dashboard';

/**
 * Configuration Object: studentsAreaScreens
 * 
 * This object contains the configuration for the students area screens.
 * It includes roles, layout, protection status, and screen configurations.
 */
export const studentsAreaScreens: ConfigSection = {
  id: 'students',
  layout: layoutWorkspace,
  protected: true,
  roles: ['LECTURER', 'STUDY_DIRECTOR', 'STUDENT'],
  tmp: 'index',
  path: 'students',
  screens: [
    {
      id: 'dashboard',
      path: '.',
      Component: DashboardScreen,
    },
  ],
};
